module.exports = __webpack_public_path__ + "static/media/md-square-outline.f08c45e6.svg";